import React, {Component} from "react";
import {connect} from 'react-redux';
import {Link, withRouter} from "react-router-dom";
import _ from 'lodash';
import {withFirebase} from 'react-redux-firebase';
import Swal from 'sweetalert2';
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MUIButton from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import Hidden from "@material-ui/core/Hidden";

import LoadingSpinner from 'utils/LoadingSpinner/';
import {pollMetaNamePH, pollMetaLocPH, pollMetaHeadPH, pollMetaDescrPH} from '../placeholders';
import {alertChangePollDescr} from '../SweetAlerts';
import {editPollInfo} from '../../actions';
import haroldDefault from "assets/img/faces/harold.jpg";

import metaPollStyle from "assets/jss/material-kit-react/views/pollTemplateSections/metaPollStyle.jsx";

class MetaSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      swalEditDescrLoading: false,
      updatedDescrip: ""
    };
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkUpdatedPollInfo();
  }

  checkUpdatedPollInfo() {
    if (this.state.swalEditDescrLoading) {
      const hasUpdatedInfo = (!_.isEmpty(this.props.poll.updated));
      if (hasUpdatedInfo) {
        console.log('getting closer.');
        const isUpdatedInfoEmpty = this.props.poll.updated.isEmpty;
        if (!isUpdatedInfoEmpty) {
          this.alertAndReset(this.props.poll.updated.poll);
          // TODO also set state data to match new shit? instead of making another API call??
        }
      }
      // TODO QUESTION above works for first call?
      // need additional check if has actually received new data, not from previous call
    }
  }

  alertAndReset(newData) {
    console.log('new poll descr data', newData.descrip);
    Swal('Saved!', 'Your poll description has been updated!', 'success');
    // this.resetSwalUserInfoState(); //NOTE DEBUG will I need to make another api call?
    this.setState({
      swalEditDescrLoading: false,
      editUserField: '',
      updatedDescrip: newData.descrip,
    });
  }

  updateDescrInfo(newData) {
    // NOTE newData is an Object, with what will be changed and the pollid to change
    // ie {"descrip": "cats inspired me to make this poll, lol, obvz"}
    console.log('update descr called', newData);
    const {editPollInfo, poll} = this.props;
    // add the pid to the new_data
    newData['pid'] = poll.data.poll_id;
    this.setState({swalEditDescrLoading: true});
    editPollInfo(newData);
  }

  renderDescrip() {
    const {classes, profile, poll, previewPoll} = this.props;

    const pollToRender = previewPoll ? previewPoll : poll;

    // this shouldn't happen, but hey, doesnt hurt
    if (pollToRender.loading) {
      return <LoadingSpinner />;
    }

    const {updatedDescrip} = this.state;
    const {descrip} = previewPoll ? pollToRender.data : pollToRender.data.pollmeta;
    let pollDescr = descrip ? descrip : pollMetaDescrPH;
    if (updatedDescrip) { pollDescr = updatedDescrip }
    const descrSection = <p className={classes.descrip}>{pollDescr}</p>;

    let can_edit = false;

    if (previewPoll) {
      can_edit = false;
    } else if (!_.isEmpty(profile.username)) {
      // NOTE shouldn't be needed, but in case somehow its not set... accidentally happened while testing
      can_edit = (profile.username === pollToRender.data.created_by.username);
    }

    if (can_edit) {
      const descrSwalParams = {
        descrInput: descrip,
        loading: this.state.swalEditDescrLoading,
        updatePollDescrCb: this.updateDescrInfo.bind(this),
      };

      return (
        <Tooltip
          id="tooltip-edit-descr"
          title="Edit description?"
          placement="left"
          classes={{tooltip: classes.tooltip}}
        >
          <MUIButton
            color="inherit"
            className={classes.linkDescrEditBtn}
            onClick={() => alertChangePollDescr(descrSwalParams)}
          >
            {/* <Link to={'/'} style={{color: 'inherit'}}> */}
              {descrSection}
            {/* </Link> */}
          </MUIButton>
        </Tooltip>
      );
    } else {
      return descrSection;
    }

  }

  render() {
    const {classes, PollHeader, previewPoll, poll, profile} = this.props;

    const pollToRender = previewPoll ? previewPoll : poll;
    const isSignedIn = profile.username !== null;

    if (pollToRender.loading || _.isEmpty(pollToRender.data)) {
      return <LoadingSpinner />;
    }

    try {
      var {user_full_name, user_location, user_pic, username} = pollToRender.data.created_by;
    } catch (e) {
      if (e instanceof TypeError && previewPoll) {
        var user_full_name =  isSignedIn ? profile.userInfo.name : pollMetaNamePH;
        var user_location = isSignedIn ? profile.userInfo.location : pollMetaLocPH;
        var user_pic = isSignedIn ? profile.userInfo.pic_url : haroldDefault;
        var username = isSignedIn ?  profile.username : 'anonymous_user';
      } else {
        //TODO where can we nav to?? every poll page has a meta section lol
        // just go Home??
        console.log('did I get here????')
      }
    }


    // NOTE this logic now gets repeated for the poll preview page
    // FIXME will still work, prob should refactor tho
    const name = user_full_name ? user_full_name : pollMetaNamePH;
    const loc = user_location ? user_location : pollMetaLocPH;
    const pollHeader = PollHeader ? PollHeader : pollMetaHeadPH;
    // const pollDescr = descrip ? descrip : pollMetaDescrPH;
    const B = (props) => <p className={classes.name} style={{fontWeight:'bold'}}>{props.children}</p>;

    const imageClasses = classNames(
      classes.profImgStyle,
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid,
      classes.imgScale,
    );

    const userProfPic = user_pic ? user_pic : haroldDefault;
    // console.log('meta state -> ', this.state);
    const isClickDisabled = previewPoll ? true : false;

    return (
      <div className={classes.section}>
        <div className={classes.bioDiv}>
          <Hidden only="xs">
            <img src={userProfPic} className={imageClasses} alt="profile pic" />
          </Hidden>
          {/* <h3 className={classes.name}>{[<strong key="name">{name}</strong>, <br key="br"/> , {loc}]} </h3> */}
          <MUIButton color="inherit" className={classes.linkUserPageBtn} disabled={isClickDisabled} >
          {/* <MUIButton color="inherit" className={`${classes.linkUserPageBtn} ${(isPreview ? classes.disableLink : '')}`}> */}
            <Link to={`/user/${username}`} style={{color: 'inherit'}}>
              <h3 className={classes.name}>
                <B>{name}</B>{loc}
              </h3>
            </Link>
          </MUIButton>
          <div className={classes.divider}></div>
          <h3 className={classes.heading}>{pollHeader}</h3>
          {/* <p className={classes.descrip}>{pollDescr}</p> */}
          {this.renderDescrip()}
        </div>
      </div>
    );
  }
}

const pageWithStylesAndFirebase = withStyles(metaPollStyle)(withFirebase(MetaSection));

function mapStateToProps(state) {
  return {
    // auth: state.firebase.auth, #FIXME auth stays signed in, profile does not!! they should be synced.
    profile: state.profile,
    poll: state.poll,
  };
}

export default withRouter(connect(mapStateToProps, {editPollInfo})(pageWithStylesAndFirebase));



// WEBPACK FOOTER //
// ./src/views/PollTemplate/MetaSection.js